import React from 'react';

import { NewzooToDatabrain } from '@intelligence/utils/constant';

// import Newzoo from '@/pages/home/assets/svg/dataSource/databarin.svg';
import Newzoo from '@/pages/intelligence/assets/svg/dataSource/newzoo.svg';
import NewzooGray from '@/pages/intelligence/assets/svg/dataSource/databarin-gray.svg';
import ArchivedMarketReport from '@/pages/intelligence/assets/svg/dataSource/archived_market_report.svg';
import SensorTower from '@/pages/intelligence/assets/svg/dataSource/sensor-tower.svg';
import Statista from '@/pages/intelligence/assets/svg/dataSource/statista.svg';
import DataAi from '@/pages/intelligence/assets/svg/dataSource/appnnie.svg';
import NPD from '@/pages/intelligence/assets/svg/dataSource/npd.svg';
import Famitsu from '@/pages/intelligence/assets/svg/dataSource/japanSales.svg';
import Twitter from '@/pages/intelligence/assets/svg/dataSource/twitter.svg';
import Fandom from '@/pages/intelligence/assets/svg/dataSource/fandom.svg';
import Hatchet from '@/pages/intelligence/assets/svg/dataSource/hatchet.svg';
import iMur from '@/pages/intelligence/assets/svg/tipicon/imur.svg';
import ampere from '@/pages/intelligence/assets/svg/dataSource/ampere.svg';
import vgi from '@/pages/intelligence/assets/svg/dataSource/vginsights.svg';
import appmagic from '@intelligence/assets/imgs/dataSource/app-magic.png';
import LevelUp from '@intelligence/assets/imgs/dataSource/levelup.png';
import './index.scss';
const datasource: any = {
  LevelUp: { img: LevelUp, name: 'LevelUp' },
  DataBrain: { img: Newzoo, name: NewzooToDatabrain },
  'Archived Market Report': { img: ArchivedMarketReport, name: 'Archived Market Report' },
  Newzoo: { img: NewzooGray, name: NewzooToDatabrain },
  'Sensor Tower': { img: SensorTower, name: 'Sensor Tower' },
  'data.ai': { img: DataAi, name: 'Data.Ai' },
  NPD: { img: NPD, name: 'NPD' },
  Statista: { img: Statista, name: 'Statista' },
  Famitsu: { img: Famitsu, name: 'Famitsu' },
  Twitter: { img: Twitter, name: 'Twitter' },
  Fandom: { img: Fandom, name: 'Fandom' },
  iMur: { img: iMur, name: '' },
  'Stream Hatchet': { img: Hatchet, name: 'Stream Hatchet' },
  Others: { img: '', name: 'Others' },
  Ampere: { img: ampere, name: 'Other Vendors' },
  VGI: { img: vgi, name: 'VGI' },
  AppMagic: { img: appmagic, name: 'AppMagic' },
};

export function datasourceInfo(sourceName: string) {
  const datasourceConfig = datasource?.[sourceName];

  if (datasourceConfig) {
    return datasourceConfig;
  }
  const target = Object.keys(datasource)?.find((item) => item.toLowerCase() === sourceName.toLowerCase());
  return target ? datasource[target] : undefined;
}

type TProps = {
  sourceName?: string;
  needCustomIcon?: boolean;
  customIcon?: React.ReactNode;
  needCustomName?: boolean;
  customName?: string;
};

export default function ReportSourceLabel(props: TProps) {
  const { sourceName } = props;

  const datasource = sourceName ? datasourceInfo(sourceName) : 'others';
  const img = datasource?.img;
  const name = datasource?.name;

  return (
    <div className="dbi-source-label-new">
      {/* <img src={img} className="dbi-source-label-new-icon" /> */}
      {props?.needCustomIcon && props?.customIcon ? (
        props.customIcon
      ) : (
        <img src={img} className="dbi-source-label-new-icon" />
      )}

      {props?.needCustomName && props?.customName ? (
        <span className="dbi-source-label-new-text">{props.customName}</span>
      ) : null}

      {!props?.needCustomName && name ? <span className="dbi-source-label-new-text">{name}</span> : null}
    </div>
  );
}
